import http from "@/settings/apiSettings"

class ParteneriDataService {
  save(data: any, idempotencyKey?: string): Promise<any> {
    return http.clientComercialOdata.post("/PAR_Parteneri", data, {
      headers: idempotencyKey ? { 'X-Idempotency-Key': idempotencyKey } : {}
    });
  }

  saveBank(data: any): Promise<any> {
    return http.clientComercialOdata.post("/PAR_BanciParteneri", data);
  }

  update(key: string, data: any): Promise<any> {
    return http.clientComercialOdata.patch(`/PAR_Parteneri(${key})`, data);
  }

  getDrepturiMele(): Promise<any> {
    return http.clientComercial.get('/PAR_Parteneri/drepturi-mele');
  }

  preia(id: string, agentNume: string, agentId?: string): Promise<any> {
    return http.clientComercial.post(`/PAR_Parteneri/${id}/preia`, { AgentNume: agentNume, AgentId: agentId ?? null });
  }

  abandoneaza(id: string, observatii: string): Promise<any> {
    return http.clientComercial.post(`/PAR_Parteneri/${id}/abandoneaza`, { Observatii: observatii });
  }

}
export default new ParteneriDataService();